import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import { QueryClient, QueryClientProvider } from '@tanstack/react-query'
import App from './App'
import LoginGate from './pages/LoginGate'
import './i18n'
import './index.css'
import { initAuth, getKeycloak } from './lib/auth'
import StatusPage from './pages/StatusPage'
import PublicVerifyPage from './pages/PublicVerifyPage'

const queryClient = new QueryClient({
  defaultOptions: {
    queries: { retry: 1, staleTime: 30_000, refetchOnWindowFocus: false },
  },
})

async function bootstrap() {
  const path = window.location.pathname
  if (path === '/status' || path.startsWith('/verify/')) {
    // public surfaces (I6/bet 4): no auth gate
    createRoot(document.getElementById('root')!).render(
      path === '/status' ? <StatusPage /> : <PublicVerifyPage />)
    return
  }
  const authenticated = await initAuth()
  const container = document.getElementById('root')!

  createRoot(container).render(
    <StrictMode>
      <QueryClientProvider client={queryClient}>
        {authenticated ? <App /> : <LoginGate onLogin={() => getKeycloak().login()} />}
      </QueryClientProvider>
    </StrictMode>,
  )
}

void bootstrap()

// PWA offline shell (P2): production only, so dev/HMR and tests are unaffected.
if (import.meta.env.PROD && 'serviceWorker' in navigator) {
  window.addEventListener('load', () => {
    navigator.serviceWorker.register('/sw.js').catch(() => {
      // offline shell is a progressive enhancement; ignore registration failures
    })
  })
}
